import { useState } from "react";
import styles from "./styles.module.css";
import { ReactComponent as BackArrowSvg } from "../../../../assets/backarrow.svg";
import { Button, Form, Label } from "semantic-ui-react";
import { Formik, ErrorMessage } from "formik";
import { InputTemp } from "../../../../app/common/form/Custom";
import {
  vendorSchema,
} from "../../../../app/validation/validationSchema";
import MyTextArea from "../../../../app/common/form/MyTextArea";
import Modal from "../../../../app/common/modals/Custom";
import { ReactComponent as ThumbsUpSvg } from "../../../../assets/navbericon/thumbsup.svg";
import { ReactComponent as CancelSvg } from "../../../../assets/cancel.svg";
import { useNavigate } from "react-router-dom";
import NewTicketImageTemp from "../../../../app/common/form/Custom/Ticket";
import { TicketForm } from "../../../../app/models/tickets";
import PrioritySelectInput from "../../../../app/common/form/Custom/Ticket/PrioritySelectInput";
import { priorityOptions } from "../../../../app/common/options/categoryOptions";
import Loading from "../../../../app/layout/Loading";
import { useStore } from "../../../../app/stores/store";
import { toast } from "react-toastify";
import { observer } from "mobx-react-lite";

const NewTicket = () => {
  const [modal, setModal] = useState("");
  const navigate = useNavigate();
  const [inputField, setInputField] = useState(new TicketForm());
  const [options, setOptions] = useState([]);
  const [imageUpload, setImageUpload] = useState<string[]>([]);
  const [imageUploadTypes, setImageUploadTypes] = useState<string[]>([]);
  const { ticketStore } = useStore();
  const { loadingInitial, addTicket, getUrl, loading } = ticketStore;

  const imageHandler = (e: any) => {
    // console.log(e.target.files[0]);
    try {
      const UPLOAD_LIMIT = Number(process.env.REACT_APP_UPLOAD_LIMIT);
      const file = e.target.files && e.target.files[0];
      if (!file) return;
      if (file.size > UPLOAD_LIMIT) {
        toast.error('File too large. Maximum upload size is 1 MB.');
        return;
      }
      const reader = new FileReader();
      reader.onload = () => {
        if (reader.readyState === 2) {
          // console.log(reader.result);
          setImageUploadTypes([...imageUploadTypes, file.type]);
          setImageUpload([
            ...imageUpload,
            reader.result!.toString(),
          ]);
        }
      };
      reader.readAsDataURL(file);
    } catch {
      // console.log("none");
      setImageUpload([]);
    }
  };
  const saveForm = async (values: any) => {
    // console.log(values);
    const urlList: string[] = [];
    for (let i = 0; i < imageUpload.length; i++) {
      const imagePayload = {
        postedFilebase64: imageUpload[i],
        documentName: `TicketImage${Math.floor(Math.random() * 6) + 1}`,
        filetype: imageUploadTypes[i],
      };
      await getUrl(imagePayload).then((data) =>
        urlList.push(data.data)
      );
    }
    if (urlList.length > 0) {
      const payload = {
        ...values,
        ticketImages: urlList,
      };
      // console.log(payload);
      addTicket(payload).then(
        (data) => data && data?.isSuccessful && setModal("true")
      );
    } else {
      toast.error("Couldn't upload images");
    }
  };

  return (
    <div className={styles.page}>
      {loadingInitial === "loading" && <Loading />}
      {modal && (
        <Modal
          variant="unstyled"
          style={{ position: "fixed", zIndex: "2" }}
          openModal={true}
          closeModal={() => setModal("")}
        >
          <div className={styles.verifyAccountModal}>
            {/* <h2>Activate Selling Permission</h2> */}

            <div className={styles.info}>
              {" "}
              <ThumbsUpSvg />
            </div>
            <div className={styles.welcomeText}>
              <p>Ticket Sent successfully</p>
            </div>

            <div className={styles.twoButton}>
              <Button
                positive
                className={styles.modalactivate}
                onClick={() => navigate("/vendor/tickets")}
              >
                <div className={styles.button}>
                  <span>Okay</span>
                </div>
              </Button>
            </div>
          </div>
        </Modal>
      )}

      <div className={styles.back}>
        <BackArrowSvg onClick={() => navigate("/vendor/tickets")} />
        <span>Go back</span>
      </div>

      <Formik
        initialValues={inputField}
        enableReinitialize
        onSubmit={saveForm}
        validationSchema={vendorSchema.ticket}
      >
        {({
          dirty,
          errors,
          getFieldProps,
          handleSubmit,
          values,
          setFieldValue,
          isValid,
          isSubmitting,
        }) => {
          return (
            <Form onSubmit={handleSubmit}>
              <div className={styles.header}>
                {" "}
                <div>New Ticket</div>
                <div className={styles.searchAndFilter}>
                  <PrioritySelectInput
                    options={priorityOptions}
                    name="priority"
                  />
                  {/* <Button
                    negative
                    className={styles.userStatus}
                  >
                    <InfoDotDangerSvg />
                    <div className={styles.positive}>
                      <span>Urgent</span>
                    </div>
                    <DangerDropDownIcon />
                  </Button> */}
                </div>
              </div>
              <div className={styles.form2}>
                <div className={styles.column1}>
                  <label htmlFor="">Subject</label>

                  <div className={styles.lone}>
                    <InputTemp
                      inputType="text"
                      label={""}
                      placeholder={"Enter subject here..."}
                      marginRight
                      // style={styles.loneInput}
                      {...getFieldProps("title")}
                    />
                    <ErrorMessage
                      name={"title"}
                      render={(error) => (
                        <Label basic color="red" content={error} />
                      )}
                    />
                  </div>
                </div>
              </div>
              <div className={styles.form}>
                <div className={styles.column1}>
                  <div className={styles.textarea}>
                    <MyTextArea
                      rows={7}
                      placeholder="Write your complaint here ....."
                      name="message"
                    />
                  </div>
                  <div className={styles.foot}>
                    <div className={styles.images}>
                      {imageUpload.length > 0 &&
                        imageUpload.map((img, index) => {
                          return (
                            <div key={index}>
                              <img
                                src={
                                  img !== ""
                                    ? `${img}`
                                    : ""
                                }
                                alt=""
                              />
                              <CancelSvg
                                onClick={() =>
                                  setImageUpload(
                                    imageUpload.filter((image, imageIndex) => {
                                      return imageIndex !== index;
                                    })
                                  )
                                }
                              />
                            </div>
                          );
                        })}
                    </div>
                    <div className={styles.edit}>
                      {/* <div className={styles.editButton}>
                        <span>Attach</span>
                        <span>
                          <AttachPinSvg />
                        </span>
                      </div> */}
                      <NewTicketImageTemp
                        onChange={(e) => imageHandler(e)}
                        btnText="Add Company Logo"
                        accept="image/*"
                        imageUpload={imageUpload}
                      />
                      <Button
                        positive
                        className={styles.bulkProduct}
                        type="submit"
                        disabled={
                          !dirty || !isValid || imageUpload.length === 0
                        }
                        // onClick={() => navigate("/vendor/new-product")}
                      >
                        <div className={styles.positive}>
                          <span>Send</span>
                          {/* <PlusCircle /> */}
                        </div>
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

export default observer(NewTicket);
